import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var appMounted = createAction(actionKey + "/MOUNTED", function () { return ({}); });
export var appUnmounted = createAction(actionKey + "/UNMOUNTED", function () { return ({}); });
//# sourceMappingURL=actions.js.map